import TransactionSummary from '../Components/TransactionSummary';
import CurrencyConverter from '../Components/CurrencyConverter';
import RequestTable from '../TransactionRequest/RequestTable';
// import { SellOfferTable } from '../TradeCurrency/SellOfferTable';
import { Ads } from './Ads';
import { DownloadAppAds } from '../Components/DownloadAppAds';
import { Transactiongraph } from './Transactiongraph';
import { SeeAll } from '../Components/SeeAll';
// import { LineGraph } from '../ExchangeRateConverter/LineGraph';
import { OneToAllTableExchange } from '../ExchangeRateConverter/OneToAllTableExchange.';
import { DashboardBuyandSellTable } from '../TradeCurrency/DashboardBuyandSellTable';
import { useNavigate } from 'react-router-dom';

function Dashboard() {
  const navigate = useNavigate();

  const handleNav = () => {
    navigate('/transactionrequest');
  };

  return (
    <div className='mx-6 pt-16 flex flex-col gap-16'>
      <TransactionSummary />
      <Transactiongraph />
      <CurrencyConverter />
      <div className='flex flex-col gap-4 w-full'>
        <div onClick={handleNav}>
          <SeeAll name='Currency Exchange Rate' seeAll={false} />
        </div>
        <OneToAllTableExchange />
      </div>
      <div className='flex flex-col gap-4'>
        <SeeAll name='Transaction Request' seeAll={true} />
        <RequestTable />
      </div>
      <DashboardBuyandSellTable />
      <Ads />
      <DownloadAppAds />
    </div>
  );
}
export default Dashboard;
